"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Panel = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Panel = ({
  className,
  header,
  children,
  noMargin,
  styles = {}
}) => {
  const panelClasses = (0, _classnames.default)(styles.panel, className);
  const contentClasses = (0, _classnames.default)(className, styles.content, {
    [styles.contentMargin]: !noMargin
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: panelClasses,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles.title,
      children: header
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: contentClasses,
      children: children
    })]
  });
};

exports.Panel = Panel;